<div class="cre-fleet-competition-results" *ngIf="competitionResults">
  <ng-container *ngIf="isTieVisible">
    {{ competitionResults.win }}-{{ competitionResults.loss }}-{{ competitionResults.tie }}
  </ng-container>
  <ng-container *ngIf="!isTieVisible">
    {{ competitionResults.win }}-{{ competitionResults.loss }}
  </ng-container>
</div>
